
export default {
  name: 'BlogPage',
  async asyncData({ app, $prismic, query, error }) {
    const blogOverview = await $prismic.api.getSingle('blog_overview', {
      lang: app.i18n.localeProperties.prismic,
    })
    let blogPosts

    if (query.tags) {
      const tagList = query.tags.split(',')

      blogPosts = await $prismic.api.query(
        [
          $prismic.predicates.at('document.type', 'blog_post'),
          $prismic.predicates.any('document.tags', tagList),
        ],
        {
          lang: app.i18n.localeProperties.prismic,
          orderings: '[document.first_publication_date desc]',
          page: 1,
          pageSize: 50,
        },
      )
    } else {
      blogPosts = await $prismic.api.query(
        $prismic.predicates.at('document.type', 'blog_post'),
        {
          lang: app.i18n.localeProperties.prismic,
          orderings: '[document.first_publication_date desc]',
          page: 1,
          pageSize: 50,
        },
      )
    }

    const tags = blogPosts.results
      .map((post) => {
        return post.tags
      })
      .flat()

    const uniqueTags = [...new Set(tags)]

    if (blogOverview && blogPosts) {
      return {
        blogOverview: blogOverview.data,
        blogPosts: blogPosts.results,
        uniqueTags,
        maxPages: blogPosts.total_pages,
      }
    } else {
      error({ statusCode: 404, message: 'Page not found' })
    }
  },
  data() {
    return {
      page: 1,
    }
  },
  head() {
    return {
      title: this.blogOverview.meta_titel + ' | ATHLYZER',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.blogOverview.meta_description,
        },
        {
          hid: 'og-title',
          property: 'og:title',
          content: this.blogOverview.meta_titel + ' | ATHLYZER',
        },
        {
          hid: 'og-desc',
          property: 'og:description',
          content: this.blogOverview.meta_description,
        },
        {
          hid: 'og-image',
          property: 'og:image',
          content:
            this.blogOverview.meta_open_graph_image?.url || '/ATHLYZER_OG.jpg',
        },
      ],
    }
  },
  watchQuery: ['page'],
  methods: {
    async prevPage() {
      this.$router.push({
        path: this.$route.path,
        query: { page: Math.min(this.page - 1, 1) },
      })

      const blogPosts = await this.$prismic.api.query(
        this.$prismic.predicates.at('document.type', 'blog_post'),
        {
          lang: this.app.i18n.localeProperties.prismic,
          orderings: '[document.first_publication_date desc]',
          page: this.$route.query.page || 1,
        },
      )

      this.blogPosts = blogPosts.results
    },
    nextPage() {
      this.$router.push({
        path: this.$route.path,
        query: { page: Math.min(this.page + 1, 1) },
      })
    },
  },
}
